import {
  GET_TRANSACTIONREPORT_STATUS_LIST,
  GET_TRANSACTIONREPORT_KEYWORD_LIST,
  TRANSACTIONREPORT_LIST_ACTION,
  TRANSACTIONREPORT_WRITE_ACTION,
} from "./action";
import {
  TRANSACTIONREPORT_STATUS_LIST_MUTATION,
  TRANSACTIONREPORT_KEYWORD_LIST_MUTATION,
} from "./mutation";
import ApiService from "@/services/ApiService";
import apiPath from "@/services/apiPath";

export default {
  state: {
    statusList: [],
    keywordList: [],
  },
  actions: {
    async [GET_TRANSACTIONREPORT_STATUS_LIST](context) {
      if (context.state.statusList.length > 0) return; // 한번만 호출.

      //const result = await ApiService.shared.getData(apiPath.ITEM_STATUS_LIST); //API가 없어서 front에서 하드코딩함
      const result = {
        code: "",
        data: [
          { code: "", desc: "전체", name: "전체", value: "" },
          { code: "SUCCESS", desc: "발행", name: "발행", value: "SUCCESS" },
          { code: "FAIL", desc: "미발행", name: "미발행", value: "FAIL" },
        ],
        text: "",
      };
      const { code, data, text } = result;
      this.commit({
        type: TRANSACTIONREPORT_STATUS_LIST_MUTATION,
        list: data || [],
      });
    },
    async [GET_TRANSACTIONREPORT_KEYWORD_LIST](context) {
      if (context.state.keywordList.length > 0) return; // 한번만 호출.

      //const result = await ApiService.shared.getData(apiPath.ITEM_STATUS_LIST); //API가 없어서 front에서 하드코딩함
      const result = {
        code: "",
        data: [
          { id: "projectName", code: "projectName", desc: "프로젝트명" },
          { id: "companyName", code: "companyName", desc: "파트너사" },
          { id: "title", code: "title", desc: "발주명" },
          { id: "orderCid", code: "orderCid", desc: "발주번호" },
          { id: "transactionReportCid", code: "transactionReportCid", desc: "거래명세서번호" },
          { id: "taxInvoiceNo", code: "taxInvoiceNo", desc: "세금계산서번호" },
        ],
        text: "",
      };
      const { code, data, text } = result;
      this.commit({
        type: TRANSACTIONREPORT_KEYWORD_LIST_MUTATION,
        list: data || [],
      });
    },
    async [TRANSACTIONREPORT_LIST_ACTION](context) {
      await context.dispatch(GET_TRANSACTIONREPORT_STATUS_LIST);
      await context.dispatch(GET_TRANSACTIONREPORT_KEYWORD_LIST);
    },
    async [TRANSACTIONREPORT_WRITE_ACTION](context) {
      //
    },
  },
  mutations: {
    [TRANSACTIONREPORT_STATUS_LIST_MUTATION](state, payload) {
      // code 로 들어오는 값을 기준 값으로 (value)
      const { list } = payload;
      state.statusList = Object.freeze(
        list.map((item, index) => Object.freeze({ ...item, index: index })),
      );
    },
    [TRANSACTIONREPORT_KEYWORD_LIST_MUTATION](state, payload) {
      // code 로 들어오는 값을 기준 값으로 (value)
      const { list } = payload;
      state.keywordList = Object.freeze(
        list.map((item, index) => Object.freeze({ ...item, index: index })),
      );
    },
  },
};
